module.exports = __webpack_public_path__ + "img/bptlb.992c86b9.svg";